/** Words shared across screens. */
export const common = {
  cancel: 'Cancel',
  save: 'Save',
  delete: 'Delete',
  close: 'Close',
  copy: 'Copy',
  copied: 'Copied',
  back: 'Back',
  loading: 'Loading…',
  retry: 'Try again',
  justNow: 'just now',
  secondsAgo: '{count}s ago',
  minutesAgo: '{count}m ago',
  hoursAgo: '{count}h ago',
  daysAgo: '{count}d ago',
} as const
